<template>
  <div class="collection-auth-component d-flex flex-column align-center">
    <h1 class="page-title font-weight-regular text-center">
      Выполните вход для инкассации
    </h1>
    <span class="page-sub-title label text-center">
      Укажите логин и пароль сотрудника с функцией инкассации
    </span>
    <v-text-field
      v-model="login"
      hide-details="auto"
      class="text-field"
      flat
      solo
    />
    <v-text-field
      v-model="password"
      hide-details="auto"
      class="text-field password-field"
      :type="showPassword ? 'text' : 'password'"
      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
      @click:append="showPassword = !showPassword"
      flat
      solo
    />
    <v-btn class="button" dark>
      Вход
    </v-btn>
  </div>
</template>

<script>
  export default {
    name: 'CollectionAuth',
    data () {
      return {
        login: '',
        password: '',
        showPassword: false,
      }
    },
  }
</script>

<style lang="less" scoped>
  .collection-auth-component {
    .label {
      display: block;
      margin-bottom: 10px;
      font-size: 18px;
      font-weight: 500;
    }

    .page-sub-title {
      margin-bottom: 24px;
    }

    .button {
      max-width: 500px;
      height: 60px;
      width: 100%;
      font-size: 18px;
      border-radius: 10px;
      background-color: @color-primary !important;
    }

    .text-field {
      max-width: 500px;
      width: 100%;
      margin-bottom: 16px;
      &.password-field {
        ::v-deep {
          .v-icon.v-icon.v-icon--link {
            color: @color-primary !important;
          }
        }
      }
      ::v-deep {
        .v-input__slot {
          height: 60px;
          border: 1px solid @color-primary !important;
        }
      }
    }
  }
</style>
